import { render, staticRenderFns } from "./TrendsLoading.vue?vue&type=template&id=573a916a&scoped=true"
import script from "./TrendsLoading.vue?vue&type=script&lang=js"
export * from "./TrendsLoading.vue?vue&type=script&lang=js"
import style0 from "./TrendsLoading.vue?vue&type=style&index=0&id=573a916a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573a916a",
  null
  
)

export default component.exports